// the tone of a job status for the app's status tag; the wording is JobStatusBookingPipe's
const STATUS_TONES : { [code : string] : string } = {
  A: 'bg-warning',
  B: '',
  C: 'bg-success',
  F: 'bg-success',
  I: 'bg-primary',
  N: 'bg-warning',
  P: 'bg-warning',
  U: 'bg-warning',
  W: 'bg-primary'
};

// a booking nobody has started on has no status yet, which is to say it is booked and no further
const DEFAULT_BOOKING_STATUS : string = 'B';

// a booking with no job card yet; a job card can be set back to Booked In, so only a missing status means there is none
export function isBookedStatus ( code : string ) : boolean {
  return !code;
}

export function statusCodeFor ( code : string ) : string {
  return code || DEFAULT_BOOKING_STATUS;
}

export function statusToneClass ( code : string ) : string {
  return STATUS_TONES[statusCodeFor(code)] || '';
}
